module.exports = __webpack_public_path__ + "img/19.d68f817f.jpg";